// extracted by extract-css-chunks-webpack-plugin
module.exports = {"categoryIconContainer":"_1HOYAg","noMargin":"_2UYO-S","categoryIcon":"_3Qpg_W"};